import React, { useState, useEffect } from "react";
import "./Eagle.css";
import eagle1 from "../images/eagle1.jpg";
import eagle2 from "../images/eagle2.jpg";

function Eagle() {
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // ✅ Fetch comments from MongoDB
  useEffect(() => {
    fetch("http://localhost:5000/api/eagle-comments")
      .then((res) => res.json())
      .then((data) => setComments(data))
      .catch((err) => console.error("Error fetching comments:", err));
  }, []);

  // ✅ Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Submit new comment
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.message.trim()) return;

    try {
      const res = await fetch("http://localhost:5000/api/eagle-comments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      setComments([data, ...comments]);
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error posting comment:", error);
    }
  };

  // ✅ Like a comment
  const handleLike = async (id) => {
    try {
      const res = await fetch(`http://localhost:5000/api/eagle-comments/${id}/like`, {
        method: "PUT",
      });
      const updated = await res.json();
      setComments(comments.map((c) => (c._id === id ? updated : c)));
    } catch (error) {
      console.error("Error liking comment:", error);
    }
  };

  return (
    <div className="eagle-page">
      <main className="eagle-content">
        <section className="eagle-hero">
          <h2>Eagles</h2>
          <p>
            Eagles are powerful birds of prey, known for their sharp vision and hunting skills.
          </p>
        </section>

        <section className="eagle-images">
          <img src={eagle1} alt="Eagle 1" />
          <img src={eagle2} alt="Eagle 2" />
        </section>

        <section className="eagle-info">
          <h3>Locations</h3>
          <p>
            Eagles are found worldwide, especially in North America, Europe, Africa, and Asia,
            often near mountains and large bodies of water.
          </p>
        </section>
      </main>

      {/* ✅ Comments Section */}
      <section className="comments-section">
        <h2>Community Comments</h2>

        <form className="comment-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email (optional)"
            value={formData.email}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Write your comment..."
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Post Comment</button>
        </form>

        <div className="comment-list">
          {comments.length === 0 ? (
            <p className="no-comments">No comments yet. Be the first!</p>
          ) : (
            comments.map((c) => (
              <div key={c._id} className="comment">
                <div className="comment-header">
                  <div className="avatar">{c.name.charAt(0).toUpperCase()}</div>
                  <div>
                    <h4>{c.name}</h4>
                    <small>{new Date(c.date).toLocaleString()}</small>
                  </div>
                </div>

                <p className="comment-text">{c.message}</p>

                <div className="comment-actions">
                  <button onClick={() => handleLike(c._id)}>👍 {c.likes}</button>
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}

export default Eagle;

